"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AppShell", {
  enumerable: true,
  get: function () {
    return _AppShell.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function () {
    return _Button.default;
  }
});
Object.defineProperty(exports, "END_REASON_IDLE", {
  enumerable: true,
  get: function () {
    return _idleClock.END_REASON_IDLE;
  }
});
Object.defineProperty(exports, "END_REASON_SIGNOUT", {
  enumerable: true,
  get: function () {
    return _idleClock.END_REASON_SIGNOUT;
  }
});
Object.defineProperty(exports, "Field", {
  enumerable: true,
  get: function () {
    return _Select.Field;
  }
});
Object.defineProperty(exports, "IDLE_DEFAULTS", {
  enumerable: true,
  get: function () {
    return _idleClock.IDLE_DEFAULTS;
  }
});
Object.defineProperty(exports, "IdleLockScreen", {
  enumerable: true,
  get: function () {
    return _IdleLockScreen.default;
  }
});
Object.defineProperty(exports, "IdleWarningBanner", {
  enumerable: true,
  get: function () {
    return _IdleWarningBanner.default;
  }
});
Object.defineProperty(exports, "PHASE_ACTIVE", {
  enumerable: true,
  get: function () {
    return _idleClock.PHASE_ACTIVE;
  }
});
Object.defineProperty(exports, "PHASE_LOCKED", {
  enumerable: true,
  get: function () {
    return _idleClock.PHASE_LOCKED;
  }
});
Object.defineProperty(exports, "PHASE_WARNING", {
  enumerable: true,
  get: function () {
    return _idleClock.PHASE_WARNING;
  }
});
Object.defineProperty(exports, "Panel", {
  enumerable: true,
  get: function () {
    return _Panel.default;
  }
});
Object.defineProperty(exports, "SAMSURVEYOR_COOKIE_DOMAIN", {
  enumerable: true,
  get: function () {
    return _cookieDomain.SAMSURVEYOR_COOKIE_DOMAIN;
  }
});
Object.defineProperty(exports, "SegmentedControl", {
  enumerable: true,
  get: function () {
    return _SegmentedControl.default;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function () {
    return _Select.default;
  }
});
Object.defineProperty(exports, "SignInGate", {
  enumerable: true,
  get: function () {
    return _SignInGate.default;
  }
});
Object.defineProperty(exports, "ToolbarDivider", {
  enumerable: true,
  get: function () {
    return _AppShell.ToolbarDivider;
  }
});
Object.defineProperty(exports, "computePhase", {
  enumerable: true,
  get: function () {
    return _idleClock.computePhase;
  }
});
Object.defineProperty(exports, "consoleSignInUrl", {
  enumerable: true,
  get: function () {
    return _signInUrl.default;
  }
});
Object.defineProperty(exports, "createDraftStore", {
  enumerable: true,
  get: function () {
    return _draftStore.default;
  }
});
Object.defineProperty(exports, "createHeartbeatSender", {
  enumerable: true,
  get: function () {
    return _heartbeat.default;
  }
});
Object.defineProperty(exports, "createIdleClock", {
  enumerable: true,
  get: function () {
    return _idleClock.default;
  }
});
Object.defineProperty(exports, "draftKey", {
  enumerable: true,
  get: function () {
    return _draftStore.draftKey;
  }
});
Object.defineProperty(exports, "formatCountdown", {
  enumerable: true,
  get: function () {
    return _IdleWarningBanner.formatCountdown;
  }
});
Object.defineProperty(exports, "parseActivityStamp", {
  enumerable: true,
  get: function () {
    return _idleClock.parseActivityStamp;
  }
});
Object.defineProperty(exports, "parseSessionEnd", {
  enumerable: true,
  get: function () {
    return _idleClock.parseSessionEnd;
  }
});
Object.defineProperty(exports, "readCookieValue", {
  enumerable: true,
  get: function () {
    return _idleClock.readCookieValue;
  }
});
Object.defineProperty(exports, "sessionCookieDomain", {
  enumerable: true,
  get: function () {
    return _cookieDomain.default;
  }
});
Object.defineProperty(exports, "useContextLabel", {
  enumerable: true,
  get: function () {
    return _useIdleSession.useContextLabel;
  }
});
Object.defineProperty(exports, "useDraftSaver", {
  enumerable: true,
  get: function () {
    return _useIdleSession.useDraftSaver;
  }
});
Object.defineProperty(exports, "useIdleSession", {
  enumerable: true,
  get: function () {
    return _useIdleSession.default;
  }
});
var _AppShell = _interopRequireWildcard(require("./AppShell"));
var _Panel = _interopRequireDefault(require("./Panel"));
var _Button = _interopRequireDefault(require("./Button"));
var _SegmentedControl = _interopRequireDefault(require("./SegmentedControl"));
var _Select = _interopRequireWildcard(require("./Select"));
var _SignInGate = _interopRequireDefault(require("./SignInGate"));
var _idleClock = _interopRequireWildcard(require("./idle/idleClock"));
var _draftStore = _interopRequireWildcard(require("./idle/draftStore"));
var _cookieDomain = _interopRequireWildcard(require("./idle/cookieDomain"));
var _signInUrl = _interopRequireDefault(require("./idle/signInUrl"));
var _heartbeat = _interopRequireDefault(require("./idle/heartbeat"));
var _useIdleSession = _interopRequireWildcard(require("./idle/useIdleSession"));
var _IdleLockScreen = _interopRequireDefault(require("./idle/IdleLockScreen"));
var _IdleWarningBanner = _interopRequireWildcard(require("./idle/IdleWarningBanner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }